import { render, staticRenderFns } from "./detail_config_dataset_group_choose.vue?vue&type=template&id=2eb27515"
import script from "./detail_config_dataset_group_choose.vue?vue&type=script&lang=js"
export * from "./detail_config_dataset_group_choose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb27515')) {
      api.createRecord('2eb27515', component.options)
    } else {
      api.reload('2eb27515', component.options)
    }
    module.hot.accept("./detail_config_dataset_group_choose.vue?vue&type=template&id=2eb27515", function () {
      api.rerender('2eb27515', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/detail_config_dataset_group_choose.vue"
export default component.exports